import * as THREE from 'three';
import {get_url_param, restrictUserInteractions, userPrevent} from '../../functions';
import { isMobile, projectMode } from '../../settings';
import { settingsData, threeJsVariables } from '../../settings';
import { ViewMode } from '../../common';
import { startProject, renderUpdateValuesOnDemand } from '../../app';
import { TransformControls } from 'three/examples/jsm/controls/TransformControls';
import { GUI } from 'three/examples/jsm/libs/dat.gui.module';
import { fitModelInViewport } from '../controls/zoomControl';
import { getSelectionsByName } from '../threejs/autoSelectionBoxes'
import { degToRad } from "three/src/math/MathUtils";
import TWEEN from '../../libs/tween.umd';
import { autoRotateTimerAction,getOrbitControlsDistanceAndPan, getWorldData,
    setMinAndMaxControlsDistance, setSmoothDistance, } from '../controls/orbitControls'
import {  
    Line3, PerspectiveCamera, CatmullRomCurve3, Box3, Vector3, BufferGeometry, 
    LineBasicMaterial, Line, WebGLRenderTarget, NearestFilter, RGBFormat,
    ShaderMaterial,OrthographicCamera, Vector2, BufferAttribute, Mesh, DoubleSide,
    RawShaderMaterial, LinearFilter,
    DepthTexture, DepthStencilFormat, UnsignedInt248Type, Color 
} from 'three';
import {
    isPostProcessingActive,
    setTransEffect,
    renderSceneToRT,
    renderTransition
} from '../post-processing/post-processing'

import { centerMarker } from '../widgets/poi/poiv3'
import { showHideButtonPlay } from '../camera-auto-tour/cameraTour';
import { updateShadowMap } from './lights';
import { menuHandler } from '../menu/menu';
import {Tooltip} from "../tooltip/Tooltip";
import { Weather } from '../weather/Weather';

export const MODE_ORBIT     = 0
//export const MODE_MAP       = 1
//export const MODE_CYLINDER  = 2
export const MODE_ANIMATION = 3

export const ANIMATION_EMPTY = 0
export const ANIMATION_INTRO = 1
export const ANIMATION_MAP_TO_ORBIT = 2

let camera_angle_h = 0
let camera_angle_v = 0
let camera_mode = MODE_ORBIT
let camera_animation = 0
let camera_animation_duration = 0.0
let camera_animation_duration2 = 0.0
let _last_max_distance = 0


const target = config.threejs.orbitControls.target;
let distance = 100
let camera = null
const _v  = new Vector3()
const _v2 = new Vector3()

/*
const pass_geometry = new BufferGeometry()
pass_geometry.setAttribute('position', new BufferAttribute(new Float32Array([-1, -1, 0, -1, 1, 0, 1, -1, 0, 1, -1, 0, -1, 1, 0, 1, 1, 0]), 3))
pass_geometry.setAttribute('uv', new BufferAttribute(new Float32Array([
    0, 0, 
    0, 1, 
    1, 0, 
    1, 0,
    0, 1, 
    1, 1
]), 2))

const layer_mesh  = new Mesh(pass_geometry, new RawShaderMaterial({
    uniforms: {
        map     : { value: null },
        scale   : { value: 1.0  },
        opacity : { value: 0.0  },
    },
    vertexShader: [
        'precision lowp float;',
        'precision lowp int;',
        'attribute vec3 position;',
        'attribute vec2 uv;',
        'varying vec2 lUv;',
        'varying vec2 lp;',
        'uniform float scale;',
        'void main() {',
            'lUv = uv;',
            'lp.x = position.x;',
            'lp.y = position.y;',
            'gl_Position = vec4(position,1.0);',
        '}'].join(''),
    fragmentShader: [
        'precision lowp float;',
        'precision lowp int;',
        'uniform sampler2D map;',
        'uniform float opacity;',
        'varying vec2 lUv;',
        'varying vec2 lp;',
        'void main(){',
            'float strength = -(0.5-opacity*0.5);',
            'float zoom = 1.0;',//
        
            'vec2 p = (lUv - 0.5) * 2.0;', 
            'float theta = atan(p.y, p.x);',
            'float rd = length(p);',
            'float ru = rd * (1.0 + strength * rd * rd) / zoom;',
            'p = vec2(cos(theta), sin(theta)) * ru / 2.0 + 0.5;',
            'vec4 cmap = texture2D(map, p);',
            'gl_FragColor = vec4(cmap.rgb,(1.5-rd*0.5)*opacity);',
        '}'].join(''),
    side: DoubleSide,
    depthTest: false,
    depthWrite: false,
    transparent: true,
}))

const layer_mesh_opacity  = new Mesh(pass_geometry, new RawShaderMaterial({
    uniforms: {
        map     : { value: null },
        scale   : { value: 1.0  },
        opacity : { value: 0.0  },
    },
    vertexShader: [
        'precision highp float;',
        'precision highp int;',
        'attribute vec3 position;',
        'attribute vec2 uv;',
        'varying vec2 lUv;',
        'varying vec2 lp;',
        'uniform float scale;',
        'void main() {',
            'lUv = uv;',
            'lp.x = position.x;',
            'lp.y = position.y;',
            'gl_Position = vec4(position,1.0);',
        '}'].join(''),
    fragmentShader: [
        'precision highp float;',
        'precision highp int;',
        'uniform sampler2D map;',
        'uniform float opacity;',
        'varying vec2 lUv;',
        'varying vec2 lp;',
        'void main(){',
            'vec4 cmap = texture2D(map, lUv);',
            'gl_FragColor = vec4(cmap.rgb,opacity);',
        '}'].join(''),
    side: DoubleSide,
    depthTest: false,
    depthWrite: false,
    transparent: true,
}))

const layer_mesh_opacity2  = new Mesh(pass_geometry, new RawShaderMaterial({
    uniforms: {
        map     : { value: null },
        scale   : { value: 1.0  },
        opacity : { value: 0.0  },
    },
    vertexShader: [
        'precision highp float;',
        'precision highp int;',
        'attribute vec3 position;',
        'attribute vec2 uv;',
        'varying vec2 lUv;',
        'varying vec2 lp;',
        'void main() {',
            'lUv = uv;',
            'lp.x = position.x;',
            'lp.y = position.y;',
            'gl_Position = vec4(position,1.0);',
        '}'].join(''),
    fragmentShader: [
        'precision highp float;',
        'precision highp int;',
        'uniform sampler2D map;',
        'uniform float opacity;',
        'uniform float scale;',
        'varying vec2 lUv;',
        'varying vec2 lp;',
        'void main(){',
            'vec4 cmap = texture2D(map, lUv);',
            'vec3 color = vec3(0.0);',
            'float total = 0.0;',
            'vec2 toCenter = vec2(0.5, 0.5) - lUv;',
            'for (float t = 0.0; t <= 50.0; t++) {',
                'float percent = t / 50.0;',
                'float weight = 4.0 * (percent - percent * percent);',
                'color += texture2D(map, lUv + toCenter * percent* (0.5-opacity*0.5)).rgb*weight;',
                'total += weight;',
            '}',
            'gl_FragColor = vec4(mix(color/total,vec3(1.0,1.0,1.0),scale), 1.0 );',
        '}'].join(''),
    side: DoubleSide,
    depthTest: false,
    depthWrite: false,
    transparent: true,
}))

const layer_gmap_material  = new ShaderMaterial({
    uniforms: {
        map     : { value: null },
        scale   : { value: 1.0  },
        opacity : { value: 0.0  },
    },
    vertexShader: [
        'varying vec3 lp;',
        'void main() {',
            'vec4 mvPosition = modelViewMatrix * vec4( position.xyz, 1.0 );',
            'lp = position.xyz;',
            'gl_Position = projectionMatrix * mvPosition;',
        '}'].join(''),
    fragmentShader: [
        'varying vec3 lp;',
        'void main(){',
            'vec3 cmap = vec3(1.0,1.0,1.0);',
            'if (lp.y>40.0){',
                'cmap = vec3(248.0/255.0,249.0/255.0,250.0/255.0);',
            '}',
            'if (lp.y>60.0){',
                'cmap = vec3(255.0/255.0,251.0/255.0,240.0/255.0);',
            '}',
            'gl_FragColor = vec4(cmap,1.0);',
        '}'].join(''),
    //side: DoubleSide,
    //depthTest: false,
    //depthWrite: false,
    //transparent: true,
})
*/

export  function PerspectiveCamera_init () {
    const fov = isMobile ? 70 : 55;
    const aspect = window.innerWidth / window.innerHeight;
    const near = 1.0 //0.1;
    const far = 4000
    /*
    (get_url_param('dev'))
        ? 3000
        : isMobile ? 2000 : 1800;
        // : isMobile ? 2500 : 2200;
    */
    camera = new PerspectiveCamera(fov, aspect, near, far);
    camera.rotation.order = 'YXZ';
    const {maxDistance} = getOrbitControlsDistanceAndPan(ViewMode.Orbit);
    const start = config.threejs.camera.start.position;
    // const cameraDirection = config.threejs.camera.start.side;

    // const {position} = settingsData.globalSettings.startCamera;
    camera.position.set(start.x,start.y,start.z);

    return camera;
}

// export function flyToBuilding (buildingIndex) {
//     const camera = threeJsVariables.perspectiveCamera;
//     const controls = threeJsVariables.orbitControls;
//     const { minDistance,maxDistance } = getOrbitControlsDistanceAndPan();
//     const {cameraVector,orbitControlsVector} = getWorldData();
//     const currentBuilding = getSelectionsByName(buildings_info[buildingIndex].name);
//     const buildingBox = new Box3().setFromObject(currentBuilding);
//     const buildingCenterPoint = buildingBox.getCenter(new Vector3());
//
//
//     let flyIsComplete = false;
//     let tick = 0;
//
//
//     const curve = new CatmullRomCurve3([
//         new Vector3(cameraVector.x,cameraVector.y, cameraVector.z),
//         // new Vector3(0,startY * 0.07, minDistance * 1.5 * direction),
//         // new Vector3(0,startY * 0.1, minDistance * 1.2 * direction),
//         new Vector3(0,startY * 0.14, minDistance * direction),
//     ]);
//
//
// }


let _cameraFlyTime = 0;
export async function flyCameraAnimation () {
    // const {postProcessing} = settingsData;

    if (!projectMode.LiteMode.isActive() || projectMode.LiteMode.isActive() && projectMode.LiteMode.modeIs('regular')) await fitModelInViewport();

    // if (postProcessing.isActive && postProcessing.depthOfFields2) {}

    // const camera = (postProcessing.isActive && postProcessing.depthOfFields2)
    //     ? postProcessing.postprocessing.camera
    //     : threeJsVariables.perspectiveCamera;

    // const camera = threeJsVariables.perspectiveCamera;
    // const controls = threeJsVariables.orbitControls;
    const { minDistance,maxDistance } = getOrbitControlsDistanceAndPan(ViewMode.Orbit);
    const startPosition = config.threejs.camera.start.position;
    const endPosition = config.threejs.camera.end.position;
    const center = config.threejs.camera.center.position;


    _cameraFlyTime = 0;
    // const time = new THREE.Clock();
    // const endTime = 8;
    settingsData.time = new THREE.Clock();
    settingsData.endTime = 8;
    // let reqAnimation;

    // debugCameraRoute();
    // return

    // const curve = new CatmullRomCurve3([
    //     new Vector3(startPosition.x, startPosition.y * 0.45, maxDistance * direction),
    //     new Vector3(150,startPosition.y * 0.22, maxDistance * direction),
    //     //new Vector3(-70,startY * 0.07, minDistance * 1.5 * direction),
    //     // new Vector3(0,startY * 0.1, minDistance * 1.2 * direction),
    //     new Vector3(endPosition.x,startPosition.y * 0.09, minDistance * 1.2 * direction),
    // ]);

    const startVector = new Vector3(startPosition.x,startPosition.y,startPosition.z);
    const endVector = new Vector3(endPosition.x,endPosition.y,endPosition.z);

    const route = generateFlyRoute(startVector,endVector,8,true);

    let lastPointDistance = config.threejs.orbitControls.autoZoomSettings.activate ? config.threejs.orbitControls.autoZoomSettings.foreshortening  : (minDistance * 2) > maxDistance ? (minDistance + maxDistance) / 2 : minDistance * 2;

    const centerVector = new Vector3();
    const line = new Line3(startVector,endPosition).getCenter(centerVector);

    if (center.x){
        centerVector.setX(center.x);
    }

    if (center.z){
        centerVector.setZ(center.z);
    }

    if (center.y){
        centerVector.setY(center.y);
    }

    // const curve = new CatmullRomCurve3([
    //     new Vector3(startPosition.x, startPosition.y * 0.45, maxDistance * direction),
    //     new Vector3(150,startPosition.y * 0.22, maxDistance * direction),
    //     //new Vector3(-70,startY * 0.07, minDistance * 1.5 * direction),
    //     // new Vector3(0,startY * 0.1, minDistance * 1.2 * direction),
    //     new Vector3(endPosition.x,endPosition.y, endPosition.z).normalize().setLength(lastPointDistance).setY(endPosition.y),
    // ]);

    const curve = new CatmullRomCurve3([
        startVector,
        centerVector,
        endVector.normalize().setLength(lastPointDistance).setY(endPosition.y),
    ]);

    settingsData.curve = curve;

    //
    // const curve = new CatmullRomCurve3(route);

   if (get_url_param('dev')){
       const points = curve.getPoints( 50 );
       const geometry = new THREE.BufferGeometry().setFromPoints( points );

       const material = new THREE.LineBasicMaterial( { color : 0xff0000 } );

       const curveObject = new THREE.Line( geometry, material );
       threeJsVariables.scene.add(curveObject);
   }

    setCameraMode(MODE_ANIMATION,ANIMATION_INTRO);
    settingsData.flyIsComplete = false;

    // function animate () {
    //     if (!flyIsComplete){
    //         controls.enabled = false;
    //
    //         const elapsedTime = time.getElapsedTime();
    //         const timeNew = elapsedTime / endTime;
    //
    //         const camPos = curve.getPoint(timeNew);
    //         const camRot = curve.getTangent(timeNew);
    //
    //         camera.position.set(camPos.x, camPos.y, camPos.z);
    //         camera.rotation.set(camRot.x, camRot.y, camRot.z);
    //
    //         if (elapsedTime > endTime) {
    //             flyIsComplete = true;
    //             controls.enabled = true;
    //             startProject();
    //             setMinAndMaxControlsDistance(ViewMode.Orbit);
    //             cancelAnimationFrame(reqAnimation);
    //             threeJsVariables.renderer.shadowMap.needsUpdate = true;
    //         }
    //
    //         reqAnimation = requestAnimationFrame(animate);
    //     }
    // }

    // animate();
}

export const setCameraMode = (mode,animation)=>{
    /*
    let scene = threeJsVariables.scene
    */
    // if (mode === MODE_ANIMATION) {
    //     //     threeJsVariables.orbitControls.enabled = false
    //     // }else{
    //     //     threeJsVariables.orbitControls.enabled = true
    //     // }

    mode === MODE_ANIMATION ?
        threeJsVariables.orbitControls.enabled = false :
        threeJsVariables.orbitControls.enabled = true;

    projectMode.LiteMode.controlsToggle(false);

    camera_mode = mode;
    camera_animation = animation;
    renderUpdateValuesOnDemand(false);
    settingsData.needsRerender = true
};

export const cameraAnimationActive = () => {
    // if (camera_mode === MODE_ORBIT)
    //     return false;
    // return true
    return camera_mode !== MODE_ORBIT;
};

export const flyCameraAnimationLoop = (delta)=> {

    if (settingsData.slideShowed && projectMode.LiteMode?.isActive()){
        const {position} = config.threejs.camera.end;
        let endVector;
        if (config.threejs.orbitControls.autoZoomSettings.activate){
             endVector = new Vector3(position.x,position.y,position.z).normalize().setLength(config.threejs.orbitControls.autoZoomSettings.foreshortening);
            threeJsVariables.perspectiveCamera.position.copy(endVector);
        } else {
            const {maxDistance,minDistance} = getOrbitControlsDistanceAndPan();
            const length = (maxDistance + minDistance) / 2;
            endVector = new Vector3(position.x,position.y,position.z).normalize().setLength(length);
        }

        threeJsVariables.perspectiveCamera.position.copy(endVector);
        settingsData.flyIsComplete = true;
        setCameraMode(MODE_ORBIT,0);
        // startProject();
        setMinAndMaxControlsDistance(ViewMode.Orbit);
        updateShadowMap();
        threeJsVariables.orbitControls.enabled = true;
        startProject();
        settingsData.projectLoaded = true;
        config.contactWidget.active && restrictUserInteractions(true);
        return;

    }

    _cameraFlyTime = _cameraFlyTime + delta/1000.0
    const timeNew = Math.min(_cameraFlyTime / settingsData.endTime,1.0)
    const camPos = settingsData.curve.getPoint(timeNew)

    threeJsVariables.perspectiveCamera.position.set(camPos.x, camPos.y, camPos.z)
    threeJsVariables.perspectiveCamera.lookAt(target.x,target.y,target.z)

    if (_cameraFlyTime > settingsData.endTime) {
        settingsData.flyIsComplete = true;
        setCameraMode(MODE_ORBIT,0)
        startProject();
        setMinAndMaxControlsDistance(ViewMode.Orbit);
        updateShadowMap();
        threeJsVariables.orbitControls.enabled = true;
        settingsData.projectLoaded = true;

    }

    config.contactWidget.active && restrictUserInteractions(true);
}

export function generateFlyRoute(pointStart, pointEnd, smoothness, clockWise) {
    const route = [];

    let cb = new Vector3(), ab = new Vector3(), normal = new Vector3();
    cb.subVectors(new Vector3(), pointEnd);
    ab.subVectors(pointStart, pointEnd);
    cb.cross(ab);
    normal.copy(cb).normalize();


    const axis = new THREE.Vector3(-1,0,-1).normalize();
    let angle = pointStart.angleTo(pointEnd);
    if (clockWise) angle = angle - Math.PI * 2;
    const angleDelta = angle / (smoothness - 1);

    for (let i = 0; i < smoothness; i++) {
        route.push(pointStart.clone().applyAxisAngle(normal, angleDelta * i));
    }


    return route;
}

function debugCameraRoute () {
    const camera = threeJsVariables.perspectiveCamera;
    const controls = threeJsVariables.orbitControls;
    controls.enablePan = true;
    controls.maxPan = undefined;
    controls.minPan = undefined;

    const { minDistance,maxDistance } = getOrbitControlsDistanceAndPan(ViewMode.Orbit);
    const startY = config.threejs.camera.start.position.y;
    const direction = config.threejs.camera.start.side;
    let flyIsComplete = false;
    let tick = 0;

    let container, stats;
    const scene = threeJsVariables.scene;
    const renderer = threeJsVariables.renderer;
    const splineHelperObjects = [];
    let splinePointsLength = 2;
    const positions = [];
    const point = new THREE.Vector3();

    const raycaster = new THREE.Raycaster();
    const pointer = new THREE.Vector2();
    const onUpPosition = new THREE.Vector2();
    const onDownPosition = new THREE.Vector2();

    const geometry = new THREE.BoxGeometry( 10, 10, 10 );
    let transformControl;

    const ARC_SEGMENTS = 200;

    const splines = {};

    const params = {
        uniform: true,
        tension: 0.5,
        centripetal: true,
        chordal: true,
        addPoint: addPoint,
        removePoint: removePoint,
        exportSpline: exportSpline
    };

    init();
    //animate();

    function init() {

        const gui = new GUI();

        gui.add( params, 'uniform' );
        gui.add( params, 'tension', 0, 1 ).step( 0.01 ).onChange( function ( value ) {

            splines.uniform.tension = value;
            updateSplineOutline();

        } );
        gui.add( params, 'centripetal' );
        gui.add( params, 'chordal' );
        gui.add( params, 'addPoint' );
        gui.add( params, 'removePoint' );
        gui.add( params, 'exportSpline' );
        gui.open();

        // Controls
        transformControl = new TransformControls( camera, renderer.domElement );
        // transformControl.addEventListener( 'change', render );
        transformControl.addEventListener( 'dragging-changed', function ( event ) {

            controls.enabled = ! event.value;

        } );
        scene.add( transformControl );

        transformControl.addEventListener( 'objectChange', function () {

            updateSplineOutline();

        } );

        document.addEventListener( 'pointerdown', onPointerDown );
        document.addEventListener( 'pointerup', onPointerUp );
        document.addEventListener( 'pointermove', onPointerMove );

        /*******
         * Curves
         *********/

        for ( let i = 0; i < splinePointsLength; i ++ ) {

            addSplineObject( positions[ i ] );

        }

        positions.length = 0;

        for ( let i = 0; i < splinePointsLength; i ++ ) {

            positions.push( splineHelperObjects[ i ].position );

        }

        const geometry = new THREE.BufferGeometry();
        geometry.setAttribute( 'position', new THREE.BufferAttribute( new Float32Array( ARC_SEGMENTS * 3 ), 3 ) );

        let curve = new THREE.CatmullRomCurve3( positions );
        curve.curveType = 'catmullrom';
        curve.mesh = new THREE.Line( geometry.clone(), new THREE.LineBasicMaterial( {
            color: 0xff0000,
            opacity: 0.35
        } ) );
        curve.mesh.castShadow = true;
        splines.uniform = curve;

        curve = new THREE.CatmullRomCurve3( positions );
        curve.curveType = 'centripetal';
        curve.mesh = new THREE.Line( geometry.clone(), new THREE.LineBasicMaterial( {
            color: 0x00ff00,
            opacity: 0.35
        } ) );
        curve.mesh.castShadow = true;
        splines.centripetal = curve;

        curve = new THREE.CatmullRomCurve3( positions );
        curve.curveType = 'chordal';
        curve.mesh = new THREE.Line( geometry.clone(), new THREE.LineBasicMaterial( {
            color: 0x0000ff,
            opacity: 0.35
        } ) );
        curve.mesh.castShadow = true;
        splines.chordal = curve;

        for ( const k in splines ) {

            const spline = splines[ k ];
            scene.add( spline.mesh );

        }

        load( [
            new Vector3(0,startY, maxDistance * direction),
            new Vector3(0,10, minDistance * direction),
        ]);

    }

    function addSplineObject( position ) {

        const material = new THREE.MeshLambertMaterial( { color: Math.random() * 0xffffff } );
        const object = new THREE.Mesh( geometry, material );

        if ( position ) {

            object.position.copy( position );

        } else {

            // object.position.x = Math.random() * 1000 - 500;
            // object.position.y = Math.random() * 600;
            // object.position.z = Math.random() * 800 - 400;
            if (positions.length){
                const last = positions.slice(-1)[0];
                object.position.x = last.x + 20;
                object.position.y = last.y + 20;
                object.position.z = last.z + 20;
            }
        }

        object.castShadow = true;
        object.receiveShadow = true;
        scene.add( object );
        splineHelperObjects.push( object );
        return object;

    }

    function addPoint() {

        splinePointsLength ++;

        positions.push( addSplineObject().position );

        updateSplineOutline();

    }

    function removePoint() {

        const point = splineHelperObjects.pop();
        splinePointsLength --;
        positions.pop();

        if ( transformControl.object === point ) transformControl.detach();
        scene.remove( point );

        updateSplineOutline();

    }

    function updateSplineOutline() {

        for ( const k in splines ) {

            const spline = splines[ k ];

            const splineMesh = spline.mesh;
            const position = splineMesh.geometry.attributes.position;

            for ( let i = 0; i < ARC_SEGMENTS; i ++ ) {

                const t = i / ( ARC_SEGMENTS - 1 );
                spline.getPoint( t, point );
                position.setXYZ( i, point.x, point.y, point.z );

            }

            position.needsUpdate = true;

        }

    }

    function exportSpline() {

        const strplace = [];

        for ( let i = 0; i < splinePointsLength; i ++ ) {

            const p = splineHelperObjects[ i ].position;
            strplace.push( `new THREE.Vector3(${p.x}, ${p.y}, ${p.z})` );

        }

        console.log( strplace.join( ',\n' ) );
        const code = '[' + ( strplace.join( ',\n\t' ) ) + ']';
        prompt( 'copy and paste code', code );

    }

    function load( new_positions ) {

        while ( new_positions.length > positions.length ) {

            addPoint();

        }

        while ( new_positions.length < positions.length ) {

            removePoint();

        }

        for ( let i = 0; i < positions.length; i ++ ) {

            positions[ i ].copy( new_positions[ i ] );

        }

        updateSplineOutline();

    }

    /* function animate() {

        requestAnimationFrame( animate );
        // render();
        // stats.update();

    }*/

    function render() {

        splines.uniform.mesh.visible = params.uniform;
        splines.centripetal.mesh.visible = params.centripetal;
        splines.chordal.mesh.visible = params.chordal;
        renderer.render( scene, camera );

    }

    function onPointerDown( event ) {

        onDownPosition.x = event.clientX;
        onDownPosition.y = event.clientY;

    }

    function onPointerUp() {

        onUpPosition.x = event.clientX;
        onUpPosition.y = event.clientY;

        if ( onDownPosition.distanceTo( onUpPosition ) === 0 ) transformControl.detach();

    }

    function onPointerMove( event ) {

        pointer.x = ( event.clientX / window.innerWidth ) * 2 - 1;
        pointer.y = - ( event.clientY / window.innerHeight ) * 2 + 1;

        raycaster.setFromCamera( pointer, camera );

        const intersects = raycaster.intersectObjects( splineHelperObjects );

        if ( intersects.length > 0 ) {

            const object = intersects[ 0 ].object;

            if ( object !== transformControl.object ) {

                transformControl.attach( object );

            }

        }

    }

}

const set_camera_angles = ()=>{
    if (camera_angle_h>(2*Math.PI)){
        camera_angle_h = camera_angle_h - 2*Math.PI
    }
    if (camera_angle_h<0){
        camera_angle_h = 2*Math.PI + camera_angle_h
    }
    let x1 = Math.cos(camera_angle_h) ;
    let y1 = 0;
    let z1 = Math.sin(camera_angle_h) ;

    let x2 = x1*Math.cos(camera_angle_v) ;
    let y2 = Math.sin(camera_angle_v) ;
    let z2 = z1*Math.cos(camera_angle_v) ;

    let x = target.x + (x2)*distance;
    let y = target.y + (y2)*distance;
    let z = target.z + (z2)*distance;
    camera.position.set(x,y,z);
    camera.lookAt(target.x,target.y,target.z);
    camera.updateMatrixWorld(false);
    settingsData.needsRerender = true;
};

const getCameraHorizontalAngle = ()=>{
    _v2.set(camera.position.x,0,camera.position.z);
    _v.set(target.x,0,target.z).sub(_v2).normalize();

    let angle = 0;
    if (camera.position.z<target.z){
        _v2.set(1,0,0);
        angle = Math.PI + _v.angleTo(_v2)
    }else{
        _v2.set(-1,0,0);
        angle = _v.angleTo(_v2)
    }
    return angle;
};

const getDistanceToTarget = (p)=>{
    let x = target.x - p.x;
    let y = target.y - p.y;
    let z = target.z - p.z;
    return Math.sqrt(x*x+y*y+z*z);
};

export const moveFromBorder = ()=>{

    let o = threeJsVariables.orbitControls;

    let x = o.object.position.x;
    let y = o.object.position.y;
    let z = o.object.position.z;
    let dx = x - o.target.x;
    let dy = y - o.target.y;
    let dz = z - o.target.z;
    let d = Math.sqrt(dx*dx+dy*dy+dz*dz);

    let max1 = o.maxDistance*0.98;
    let step = (d-max1);
    dx = (dx/d)*step;
    dy = (dy/d)*step;
    dz = (dz/d)*step;

    const duration = {x:0};
    new TWEEN.Tween(duration) 
    .to({x:1}, 200).easing(TWEEN.Easing.Linear.None).onUpdate(() => {
        o.object.position.x = x - dx*duration.x;
        o.object.position.y = y - dy*duration.x;
        o.object.position.z = z - dz*duration.x;
    }).onComplete(()=>{

    }).start()
};

export const OrbitToMap = ()=>{
    if (camera_mode===MODE_ANIMATION || settingsData.activeViewMode !== ViewMode.Orbit){
        return
    }

    if (projectMode.LiteMode.isActive()){
        projectMode.LiteMode.mapAnimation('toMap');
        setTimeout(() => {
            menuHandler({target: {dataset: {menuItem: 'map'}}},config.general);
        },1000);

        return;
    }

    userPrevent(true);

    if (Weather.isActive()) {
        Weather.toggle('disable');
    }

    autoRotateTimerAction('cancel')
    setCameraMode(MODE_ANIMATION,ANIMATION_MAP_TO_ORBIT)
    camera_animation_duration = 0.99
    camera_animation_duration2 = 0.0

    let bgColor = new Color()
    bgColor.copy(threeJsVariables.scene.background)
    threeJsVariables.scene.background.set(0xf1f2f3)

    let angle = getCameraHorizontalAngle()
    let dist = getDistanceToTarget(camera.position)
    
    setTransEffect(true,camera_animation_duration2,camera_animation_duration)

    const duration = {x:0}
    new TWEEN.Tween(duration) 
    .to({x:1}, 1500).easing(TWEEN.Easing.Linear.None).onUpdate(() => {
        if (!isPostProcessingActive()){
            sceneGroupHide('Background')
            sceneGroupHide('async env')
            sceneGroupHide('Project Buildings')
            sceneGroupHide('buildingsLabelsGroup')
        }

        //camera_animation_duration = 0.99 //-duration.x
 
        distance = dist + (1100-dist)*duration.x

        camera_animation_duration = 0.99 - Math.max(0,(distance-400)/(1100-400))
        camera_animation_duration2 = Math.max(0,(distance-900)/(1100-900))
        //camera_animation_duration = Math.min(camera_animation_duration,0.99)

        camera_angle_h = angle + (degToRad(0)-angle)*duration.x
        camera_angle_v = degToRad(10) + (degToRad(90)-degToRad(10))*duration.x
        set_camera_angles()
        setTransEffect(true,camera_animation_duration2,camera_animation_duration)

    }).onComplete(()=>{
        
        if (!isPostProcessingActive()){
            sceneGroupShow('Background')
            sceneGroupShow('async env')
            sceneGroupShow('Project Buildings')
            sceneGroupShow('buildingsLabelsGroup')
        }

        threeJsVariables.scene.background.set(bgColor)
        userPrevent(false);

        setTransEffect(false,0.0,0.0)

        camera_animation_duration = 1.0
        camera_animation_duration2 = 0.0
        threeJsVariables.orbitControls.enabled = true
        centerMarker()
        document.querySelector('[data-menu-item="map"]').click()
        threeJsVariables.orbitControls.enabled = false
        
        setTimeout(()=>{
            const endPosition = config.threejs.camera.end.position
            distance = Math.min(getDistanceToTarget(endPosition),threeJsVariables.orbitControls.maxDistance)*0.98
            camera_angle_h = degToRad(30)
            camera_angle_v = degToRad(0)
            set_camera_angles()
            camera.lookAt(target.x,target.y,target.z)
            setCameraMode(MODE_ORBIT,0)
        },200)

    }).start()

}


const sceneGroupHide = (name)=>{
    let scene = threeJsVariables.scene
    for (let i=0;i<scene.children.length;i++){
        let a = scene.children[i]
        if (a.name===name){
            a.visible = false
            break;
        }
    }
}
const sceneGroupShow = (name)=>{
    let scene = threeJsVariables.scene
    for (let i=0;i<scene.children.length;i++){
        let a = scene.children[i]
        if (a.name===name){
            a.visible = true
            break;
        }
    }
}

export const transferToBuilding = (zoom)=>{
    if (camera_mode===MODE_ANIMATION || settingsData.activeViewMode === ViewMode.Cylinder){
        return
    }

    if (projectMode.LiteMode.isActive()){
        projectMode.LiteMode.mapAnimation('toOrbit');
        setCameraMode(MODE_ORBIT,0)
        showHideButtonPlay('show');
        // projectMode.LiteMode.skyAnimationToggle('play');
       return;
    }

    userPrevent(true);

    const polarDegrees = config.threejs.animations.mapToOrbitPolarDegrees || 10;

    let bgColor = new Color()
    bgColor.copy(threeJsVariables.scene.background)
    threeJsVariables.scene.background.set(0xf1f2f3)

    autoRotateTimerAction('cancel')
    setCameraMode(MODE_ANIMATION,ANIMATION_MAP_TO_ORBIT)
    camera_animation_duration = 0.0
    camera_animation_duration2 = 0.0

    const endPosition = config.threejs.camera.end.position
    let dist = Math.min(getDistanceToTarget(endPosition),threeJsVariables.orbitControls.maxDistance)*0.98

    setTransEffect(true,camera_animation_duration2,camera_animation_duration)

    const duration = {x:0}
    new TWEEN.Tween(duration) 
    .to({x:1}, 1500).easing(TWEEN.Easing.Linear.None).onUpdate(() => {
        if (!isPostProcessingActive()){
            sceneGroupHide('Background')
            sceneGroupHide('async env')
            sceneGroupHide('Project Buildings')
            sceneGroupHide('buildingsLabelsGroup')
        }


        //camera_animation_duration = duration.x

        distance = 1100.0 + (dist-1100.0)*duration.x

        camera_animation_duration = 0.99 - Math.max(0,(distance-400)/(1100-400))
        camera_animation_duration2 = Math.max(0,(distance-700)/(1100-700))

        camera_angle_h = degToRad(0) + (degToRad(10)-degToRad(0))*duration.x
        camera_angle_v = degToRad(90) + (degToRad(polarDegrees)-degToRad(90))*duration.x
        set_camera_angles()

        camera.updateProjectionMatrix()

        setTransEffect(true,camera_animation_duration2,camera_animation_duration)

    }).onComplete(()=>{
        if (!isPostProcessingActive()){
            sceneGroupShow('Background')
            sceneGroupShow('async env')
            sceneGroupShow('Project Buildings')
            sceneGroupShow('buildingsLabelsGroup')
        }

        camera_animation_duration = 1.0
        camera_animation_duration2 = 0.0

        threeJsVariables.scene.background.set(bgColor)
        threeJsVariables.orbitControls.target.set(target.x,target.y,target.z)
        setCameraMode(MODE_ORBIT,0)
        
        setTransEffect(false,0.0,0.0)

        if (Weather.isActive()) {
            Weather.toggle('enable');
        }

        autoRotateTimerAction('update')
        showHideButtonPlay('show');
        userPrevent(false);
    }).start()
}

const updateCameraPositionByDistance = ()=>{
    let dist = getDistanceToTarget(camera.position);
    let max = threeJsVariables.orbitControls.maxDistance;
    if (dist>=threeJsVariables.orbitControls.maxDistance){
        let x = (target.x - camera.position.x)/dist;
        let y = (target.y - camera.position.y)/dist;
        let z = (target.z - camera.position.z)/dist;
        max = max*0.98;
        camera.position.x = target.z - x*max;
        camera.position.y = target.y - y*max;
        camera.position.z = target.z - z*max
    }
};

export const update = (delta)=>{

    if (_last_max_distance !== threeJsVariables.orbitControls.maxDistance) {
        updateCameraPositionByDistance();
        _last_max_distance = threeJsVariables.orbitControls.maxDistance;
    }

    if (camera_mode === MODE_ANIMATION) {
        switch (camera_animation) {
            case ANIMATION_INTRO: flyCameraAnimationLoop(delta);
                                  break;
            //case ANIMATION_MAP_TO_ORBIT: animation_map_to_orbit(delta)
            //                      break;

        }

        settingsData.needsRerender = true
    }
};

export const render  = (delta,renderer,scene,camera)=>{
    if (camera_mode === MODE_ANIMATION){
        if (camera_animation===ANIMATION_MAP_TO_ORBIT){
            if (camera_animation_duration<1.0){

                sceneGroupShow('Background');
                sceneGroupShow('async env');
                sceneGroupShow('Project Buildings');
                sceneGroupShow('buildingsLabelsGroup');

                let scene = threeJsVariables.scene;
                renderSceneToRT(renderer,scene,camera);

                //
                sceneGroupHide('Background');
                sceneGroupHide('async env');
                sceneGroupHide('Project Buildings');
                sceneGroupHide('buildingsLabelsGroup');

                renderTransition(renderer)
            }
        }
    }


};

